import React from "react";

function formatNum(v) {
  if (v == null) return "—";
  if (Math.abs(v) >= 1000) return Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 });
  return Number(v).toFixed(2);
}

export default function KpiComparisonTable({ kpis = [], filterSection = "all" }) {
  const filtered =
    filterSection === "all"
      ? kpis
      : kpis.filter((k) => String(k.section || "").toLowerCase().includes(filterSection));

  if (!filtered.length) {
    return (
      <p style={{ color: "#6b7280", fontSize: "0.85rem", margin: 0 }}>
        No KPI data available for comparison. Complete data points and generate your scorecard first.
      </p>
    );
  }

  return (
    <div className="kpi-table-wrap">
      <table className="benchmark-kpi-table">
        <thead>
          <tr>
            <th>KPI</th>
            <th>Your value</th>
            <th>Benchmark</th>
            <th>Gap</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((kpi) => (
            <tr key={kpi.code}>
              <td>
                <div style={{ fontWeight: 600, color: "#111827" }}>{kpi.name}</div>
                <div style={{ fontSize: "0.7rem", color: "#9ca3af" }}>{kpi.code}</div>
              </td>
              <td>
                {formatNum(kpi.orgValue)} {kpi.unit}
              </td>
              <td>
                {formatNum(kpi.benchmarkValue)} {kpi.unit}
              </td>
              <td style={{ color: kpi.gap > 0 ? "#dc2626" : kpi.gap < 0 ? "#059669" : "#6b7280" }}>
                {kpi.gap != null ? `${kpi.gap > 0 ? "+" : ""}${formatNum(kpi.gap)}` : "—"}
                {kpi.gapPercent != null && (
                  <div style={{ fontSize: "0.7rem" }}>({kpi.gapPercent.toFixed(0)}%)</div>
                )}
              </td>
              <td>
                <span className={`status-pill ${kpi.status}`}>
                  {kpi.status === "ahead"
                    ? "Ahead"
                    : kpi.status === "behind"
                      ? "Behind"
                      : kpi.status === "on_par"
                        ? "On par"
                        : "No data"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
